module.exports = __webpack_public_path__ + "img/ico-home.a3faa43e.svg";